import { useSuspense } from "@root/api/tools/axios";
import { settingsAxiosInstance } from ".";

interface IFupFieldOption {
  label: string;
  value: string;
}

export interface IFupField {
  isMultiple: true;
  isActive: boolean;
  label: string;
  type: "list" | "number" | "text" | "bool" | "date" | "listMultiple";
  value: string;
  required?: boolean;
  options?: IFupFieldOption[];
}

export type TGetFupSettingsResponse = IFupField[];

export const useSuspenseGetFupAdditionalFields = () => {
  return useSuspense(
    () =>
      settingsAxiosInstance.get<TGetFupSettingsResponse>("/fup/fields", {
        withCredentials: true,
      }),
    []
  );
};
